import ItemManufacture from '../item-manufacture/item-manufacture.vue'
import IcArrowLeftPagination from '@/assets/svg/ic-arrow-left-pagination.svg?inline'
import IcArrowRightPagination from '@/assets/svg/ic-arrow-right-pagination.svg?inline'

export default {
  name: 'ManufactureSelectForm',
  components: {
    ItemManufacture,
    IcArrowLeftPagination,
    IcArrowRightPagination
  },
  props: {
    city: {
      /**
       * объект вида
       * {
          "id": 0,
          "title": "string",
          "manufactures": [
            {
              "id": 12,
              "title": "Гастелло",
              "city_id": 2,
              "coordinates": {},
              "current_admin": {
                "admin_id": 1,
                "first_name": "Валентин",
                "last_name": "Гусев"
              }
            }
          ]
        }
       */
      type: Object,
      required: true
    },
    paginationSize: {
      type: Number,
      default: 15
    }
  },
  data() {
    return {
      selectedManufacture: null,
      currentPage: 1,
    }
  },
  computed: {
    pageItems() {
      if (this.city.manufactures) {
        const start = (this.currentPage - 1) * this.paginationSize
        const result = this.city.manufactures.slice(start, start + this.paginationSize)
        return result
      }
      return []
    },
    disabledPrev() {
      if (this.city.manufactures) {
        return this.currentPage === 1
      }
      return true
    },
    disabledNext() {
      if (this.city.manufactures) {
        const start = (this.currentPage - 1) * this.paginationSize
        const checkIndex = start + this.paginationSize
        return this.city.manufactures[checkIndex] === undefined
      }
      return true
    }
  },
  methods: {
    onSelectItem(event) {
      this.selectedManufacture = event
    },
    paginationPrev() {
      if (!this.disabledPrev) {
        this.currentPage = this.currentPage - 1
      }
    },
    paginationNext() {
      if (!this.disabledNext) {
        this.currentPage = this.currentPage + 1
      }
    },
    submitManufacture() {
      this.$emit('submit-manufacture', {
        selectedCity: this.city,
        selectedManufacture: this.selectedManufacture
      })
    }
  }
}